import { LambdaSchema } from "./types";

const schema: LambdaSchema = {
  columns: [
    { key: "platform", label: "platform" },
    { key: "job_name", label: "job_name" },
    { key: "summarize_job_name", label: "summarize_job_name" },
    { key: "note_length_chars", label: "note_length_chars" },
    { key: "llm_calls", label: "llm_calls" }
  ],
};

export default schema;

